export type AbilityMode = 'none' | 'airstrike' | 'barrier' | 'special';

export interface AbilityDef {
  id: string;
  name: string;
  short: string;
  desc: string;
  cooldown: number;
  key: string;
  cost?: number;
  unlocked: boolean;
}

export const ABILITIES: AbilityDef[] = [
  {
    id: 'airstrike',
    name: 'Orbital Spear',
    short: 'SPEAR',
    desc: 'Click battlefield. Delayed orbital strike. Massive AoE.',
    cooldown: 55,
    key: 'Q',
    unlocked: true,
  },
  {
    id: 'barrier',
    name: 'Hardlight Barrier',
    short: 'BARRIER',
    desc: 'Click on path. Enemies stop and attack its HP, slowing their advance until it breaks or expires.',
    cooldown: 25,
    key: 'W',
    cost: 30,
    unlocked: true,
  },
  {
    id: 'rollingdeath',
    name: 'Rolling Death',
    short: 'ROLLING',
    desc: 'Launches six rolling bombs from the bastion up every enemy lane.',
    cooldown: 75,
    key: 'E',
    unlocked: true,
  },
  {
    id: 'emp',
    name: 'EMP Lance',
    short: 'EMP',
    desc: 'Stun all enemies briefly. Emergency only.',
    cooldown: 90,
    key: 'R',
    unlocked: true,
  },
];

export type DroneMode = 'ATTACK' | 'BOOST' | 'SHIELD';
export const DRONE_MODES: DroneMode[] = ['ATTACK', 'BOOST', 'SHIELD'];
